import styled from "styled-components";
import Icon from "../../../../../../components/icon";
import { theme } from "../../../../../../helpers/theme";
import { ReactComponent as DedicatedWarehouseSVG } from "../../../../../../assets/icons/warehouse-dedicated.svg";
import { ReactComponent as DedicatedWarehouseActiveSVG } from "../../../../../../assets/icons/warehouse-dedicated-active.svg";
import FormFieldInfo from "../../../../../common-views/offer-form/components/form-field-info/form-field-info";
import { IsPriceVisible, TwoTypesOfOfferHandler } from "../../../helpers/types";



interface DedicateWarehouseProps {
    isActive: boolean,
    isPriceVisible: IsPriceVisible,
    isDedicateWarehouseDisable: boolean,
    //isComponentNoMatchingWarehousesVisible: boolean,
    requires_consultation: boolean,
    min_value: number,
    max_value: number,
    isTwoTypesOfOffer: TwoTypesOfOfferHandler,
    handleClik: (value: number) => void,
}

export const DedicateWarehouse = ({
    isActive,
    isPriceVisible,
    isDedicateWarehouseDisable,
    //isComponentNoMatchingWarehousesVisible,
    requires_consultation,
    min_value,
    max_value,
    isTwoTypesOfOffer,
    handleClik
}: DedicateWarehouseProps) => {

    return (
        <Container
            isActive={isActive}
            onClick={() => handleClik(0)}
            disabled={isDedicateWarehouseDisable ? true : (isTwoTypesOfOffer.active === 0 || isTwoTypesOfOffer.active === 2) ? false : true}
        >
            <DedicateWarehouseIcon>
                <Icon
                    width="29px"
                    height="32px"
                    noPadding
                    icon={isActive ? <DedicatedWarehouseActiveSVG /> : <DedicatedWarehouseSVG />}
                />
            </DedicateWarehouseIcon>
            <DedicateWarehouseMessageContainer>
                <DedicateWarehouseTitle isActive={isActive}>Magazyn dedykowany</DedicateWarehouseTitle>
                {((min_value === null && max_value === null) || (!isPriceVisible.value_dedicate_warehouse)) ?
                    <></> :
                    <DedicateWarehouseValue isActive={isActive}>
                        {(min_value === -1 || max_value === -1 || min_value === Infinity || max_value === Infinity)
                            ? null
                            : (
                                min_value !== max_value
                                    ? `${min_value.toFixed(2)} - ${max_value.toFixed(2)} zł`
                                    : `${min_value.toFixed(2)} zł`
                            )
                        }

                        {requires_consultation ? <span> (Konsultacja)</span> : null}
                    </DedicateWarehouseValue>}

            </DedicateWarehouseMessageContainer>
            <InfoWrapper>
                <FormFieldInfo
                    noPadding={true}
                    popoverLabel={""}
                    popoverContent={"Lorem Ipsum 1"}
                />
            </InfoWrapper>
        </Container>
    );
};



const Container = styled.button<{ isActive: boolean }>`
position:relative;
display:flex;
flex-direction: row;
flex-wrap:wrap;
justify-content:flex-start;
align-items:center;
border: 1px solid #0100C6;
border: ${(props: any) => (props.isActive ? `1px solid ${theme.colors.blue01_active}` : `1px solid ${theme.colors.gray02_border}`)};
border-radius: 8px;
width:49%;
min-width:250px;
padding: 20px 16px;
background-color:${theme.colors.gray04_background};
cursor: pointer;
 :hover {
     border: 1px solid ${theme.colors.gray02_border};
     box-shadow: 1px 1px 1px ${theme.colors.gray02_border};
   }
:disabled{
    border-color: ${theme.colors.gray02_border};
    opacity: 0.4;
    cursor: pointer;
    box-shadow: none;
    cursor:none;
}
`;
const DedicateWarehouseIcon = styled.div`
width:20%;

`;
const DedicateWarehouseMessageContainer = styled.div`
display:flex;
flex-direction: column;
flex-wrap:wrap;
justify-content:flex-start;
padding-left:15px;
width:70%;
`;
const DedicateWarehouseTitle = styled.div<{ isActive: boolean }>`
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: ${theme.fontWeight.normal};
font-size: 14px;
line-height: 20px;
color: ${(props: any) => (props.isActive ? `${theme.colors.blue01_active}` : `${theme.colors.black_primaryText}`)};
text-align: left;
`;
const DedicateWarehouseValue = styled.div<{ isActive: boolean }>`
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: ${theme.fontWeight.normal};
font-size: 12px;
line-height: 18px;
color: ${(props: any) => (props.isActive ? `${theme.colors.blue01_active}` : `${theme.colors.black_primaryText}`)};
text-align: left;
// @media (max-width:560px){
//    max-width:150px;
// }
`;
const InfoWrapper = styled.div`
position:absolute;
top:3px;
right:10px;
display:flex;
width:20px;
height:20px;
width:20px;
& div{
    width:20px;
    height:20px;
}

`;